import React, { } from 'react';
import PrimaryContainer from "../../../customUI/PrimaryContainer";
import { useStyles } from '../../digital-pr/styles/index.style';
import logo from '../../../images/logo-2.svg';

const NoLocations = () => {
    const classes = useStyles();

    return (
        <div className={classes.banner_wrapper}>
            <>
              <PrimaryContainer>
                <div style={{ maxWidth: 1000, margin: 'auto' }}>
                  <div className={classes.center}>
                      <img src={logo} className={classes.topLogo} alt="Hennessey Logo" height="75" />
                  </div>
                  <p className={classes.headingTitle}>Enhance your SEO with citations search engines will love</p>
                  <p className={classes.paragraph}>
                    Building a trusted link network that points back to your site increases your site&apos;s value to Google and gives potential customers new ways to discover you. As a result, your organic traffic will grow naturally, bringing potential new business to your site.
                  </p>
                  <p className={classes.paragraph}>
                    Our partnership with Yext focuses on strategic citation campaigns that optimize your SEO through high-authority, Google-approved citation networks.
                  </p>
                  <div className={classes.center}>
                      <p className={classes.bigText} onClick={() => {
                        window.open(
                          'https://hennessey.zendesk.com/hc/en-us/requests',
                          '_blank'
                        );
                      }}
                      role="presentation"
                      style={{ cursor: 'pointer' }}>Hungry to know more? Contact your Account Manager to discuss or get started.</p>
                  </div>
                </div>
              </PrimaryContainer>
            </>    
        </div>
      );
}

export default NoLocations